import instance from './http.service';

const ConfigService = {
  getConfig: async () => {
    return instance.get('/config');
  },
};

export default ConfigService;
